"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelValueSticker = exports.LabelValueStickerWrapper = void 0;
const tslib_1 = require("tslib");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const typestyle_1 = require("typestyle");
const Styles_1 = require("../Styles");
const LabelType_1 = require("./LabelType");
function LabelValueStickerWrapper(props) {
    switch (props.category) {
        case 'CERTIFICATION':
            return LabelValueSticker(props.value, 'green', (0, LabelType_1.labelCategoryToIcon)(props.category));
        case 'WARNING':
            return LabelValueSticker(props.value, props.isSevere ? 'yellow' : 'blue', (0, LabelType_1.labelCategoryToIcon)(props.category, props.isSevere));
        case 'SENSITIVITY':
            return LabelValueSticker(props.value, props.isSevere ? 'violet' : 'neutral', (0, LabelType_1.labelCategoryToIcon)(props.category, props.isSevere));
        default:
            return LabelValueSticker(props.value, 'neutral', null);
    }
}
exports.LabelValueStickerWrapper = LabelValueStickerWrapper;
function LabelValueSticker(value, color, icon) {
    let stickerContent = (0, LabelType_1.localizeLabelTypeName)((0, LabelType_1.stringtoLabelType)(value));
    if (!stickerContent)
        stickerContent = value;
    return (icon
        ? (react_1.default.createElement(widgets_1.StickerWidget, { stickerType: color, icon: icon, className: (0, typestyle_1.style)(Styles_1.LabelValueStickerStyle) }, stickerContent))
        : (react_1.default.createElement(widgets_1.StickerWidget, { stickerType: color, className: (0, typestyle_1.style)(Styles_1.LabelValueStickerStyle) }, stickerContent)));
}
exports.LabelValueSticker = LabelValueSticker;
//# sourceMappingURL=LabelValueSticker.js.map